import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentPlanYear: {
        id: 'ml.quoteandbind.common.policySummary.year',
        defaultMessage: 'year'
    },
    paymentPlanMonth: {
        id: 'ml.quoteandbind.common.policySummary.month',
        defaultMessage: 'month'
    },
    paymentPlanTwoWeeks: {
        id: 'ml.quoteandbind.common.policySummary.paymentPlanTwoWeeks',
        defaultMessage: 'two weeks'
    },
    totalPremium: {
        id: 'ml.quoteandbind.common.policySummary.Total Premium:',
        defaultMessage: 'Total Premium: '
    },
    termTypeYear: {
        id: 'ml.quoteandbind.common.policySummary.termType.year',
        defaultMessage: 'year'
    },
    termTypeHalfYear: {
        id: 'ml.quoteandbind.common.policySummary.termType.6 month',
        defaultMessage: '6 month'
    },
    whatIsNotIncluded: {
        id: 'ml.quoteandbind.common.policySummary.What is not included in this premium?',
        defaultMessage: 'What is not included in this premium?'
    },
    whatIsNotIncludedDesc: {
        id: 'ml.quoteandbind.common.policySummary.The premium shown does not include fees or taxes.',
        defaultMessage: 'The premium shown does not include fees or taxes.'
    },
    paymentMethod: {
        id: 'ml.quoteandbind.common.policySummary.Payment Method:',
        defaultMessage: 'Payment Method: '
    },
    annualPayment: {
        id: 'ml.quoteandbind.common.policySummary.Annual payment',
        defaultMessage: 'Annual payment'
    },
    semiAnnualPayment: {
        id: 'ml.quoteandbind.common.policySummary.Semi-Annual payment',
        defaultMessage: 'Semi-Annual payment'
    },
    payByMortgagee: {
        id: 'ml.quoteandbind.common.policySummary.Pay by Mortgagee',
        defaultMessage: 'Pay by Mortgagee'
    },
    monthlyPayment: {
        id: 'ml.quoteandbind.common.policySummary.Monthly payment',
        defaultMessage: 'Monthly payment'
    },
    twiceAMonth: {
        id: 'ml.quoteandbind.common.policySummary.Twice a month',
        defaultMessage: 'Twice a month'
    },
    twoPay: {
        id: 'ml.quoteandbind.common.policySummary.Two Pay',
        defaultMessage: 'Two Pay'
    },
    fourPay: {
        id: 'ml.quoteandbind.common.policySummary.Four Pay',
        defaultMessage: 'Four Pay'
    },
    editPayment: {
        id: 'ml.quoteandbind.common.policySummary.Edit Payment',
        defaultMessage: 'Edit Payment'
    },
    yourTotalDiscounts: {
        id: 'ml.quoteandbind.common.policySummary.Your total discounts',
        defaultMessage: 'Your total discounts'
    },
    paymentSchedule: {
        id: 'ml.quoteandbind.common.policySummary.Payment Schedule:',
        defaultMessage: 'Payment Schedule: '
    },
    totalDiscount: {
        id: 'ml.quoteandbind.common.policySummary.Total Discounts:',
        defaultMessage: 'Total Discounts: '
    },
    seeAllOfMyDiscounts: {
        id: 'ml.quoteandbind.common.policySummary.See all of my discounts',
        defaultMessage: 'See all of my discounts'
    },
    hideDiscounts: {
        id: 'ml.quoteandbind.common.policySummary.Hide discounts',
        defaultMessage: 'Hide discounts'
    },
    adjustedAnnualPremium: {
        id: 'ml.quoteandbind.common.policySummary.Adjusted Annual Premium',
        defaultMessage: 'Adjusted Annual Premium'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.common.policySummary.Effective Date',
        defaultMessage: 'Effective Date'
    },
    effectiveDateHelpText: {
        id: 'ml.quoteandbind.common.policySummary.Clicking on the date will take you back to the effective date page. You can select a different date for the policy change.',
        defaultMessage: 'Clicking on the date will take you back to the effective date page. You can select a different date for the policy change.'
    },
    effectiveDateHelpTitle: {
        id: 'ml.quoteandbind.common.policySummary.How to change my effective date?',
        defaultMessage: 'How to change my effective date?'
    },
    premiumBeforeChange: {
        id: 'ml.quoteandbind.common.policySummary.Premium Before Change',
        defaultMessage: 'Premium Before Change:'
    },
    adjustedFullTermPremium: {
        id: 'ml.quoteandbind.common.policySummary.Adjusted Full Term Premium:',
        defaultMessage: 'Adjusted Full Term Premium:'
    },
    amountDueForChange: {
        id: 'ml.quoteandbind.common.policySummary.Amount Due For Change:',
        defaultMessage: 'Amount Due For Change:'
    },
    submitChanges: {
        id: 'ml.quoteandbind.common.policySummary.Submit Changes',
        defaultMessage: 'Submit Changes'
    },
    effectiveDateConfirmationText: {
        id: 'ml.quoteandbind.common.policySummary.Make these policy changes now for effective date x',
        defaultMessage: 'Make these policy changes now for effective date {date}'
    },
    submitAllChanges: {
        id: 'ml.quoteandbind.common.policySummary.Submit all changes',
        defaultMessage: 'Submit all changes'
    },
    cancelChanges: {
        id: 'ml.quoteandbind.common.policySummary.Cancel changes',
        defaultMessage: 'Cancel Changes'
    },
    makeMoreChanges: {
        id: 'ml.quoteandbind.common.policySummary.Make More Changes',
        defaultMessage: 'Make More Changes'
    },
    summaryPleaseNoteText: {
        id: 'ml.quoteandbind.common.policySummary.PleaseNote',
        defaultMessage: 'Please Note'
    },
    summaryPleaseNoteTextContent: {
        id: 'ml.quoteandbind.common.policySummary.WeMayAsk',
        defaultMessage: 'We may ask for supporting documents related to these discounts after you purchase a policy. '
    }
});
